<template>
  <div class="">
    <Card class="">
      <template #title> Düzenle Diyet Tanım </template>
      <template #content>

        <div class=" grid">
          <div class="col-12">
            <Panel class="pb-5">

              <div class=" grid">
                <div class="col-5">
                  <div class="formgrid grid">
                    <div class="field col col-12">
                      <label for="DiyetAd" class="font-bold block">Diyet Adı</label>
                      <InputText id="DiyetAd" type="text" v-model="DiyetAd" class="text-base text-color w-full"
                        :invalid="this.Valid.DiyetAd" />
                    </div>
                    <div class="field col col-12 flex-auto">
                      <label for="Gun" class="font-bold block">Gün</label>
                      <InputNumber v-model="Gun" showButtons buttonLayout="horizontal" :step="1" :min="0" :max="999"
                        :invalid="this.Valid.Gun" fluid class="text-base text-color w-full">
                        <template #incrementbuttonicon>
                          <span class="pi pi-plus" />
                        </template>
                        <template #decrementbuttonicon>
                          <span class="pi pi-minus" />
                        </template>
                      </InputNumber>
                    </div>
                    <div class="col-12">
                      <div class="mt-1 mb-2 mr-3">
                        <Button icon="pi pi-plus " size="small" label="Yeni" @click="_DiyetElemanModal()" />
                      </div>
                      <BasicDataTable_RowGroup v-if="DataTable_render" :columns="columns" :data="DiyetDetay"
                        v-on:set-child-data="getDataChild" :editbutton="true" group_name="OgunAd" />
                    </div>
                  </div>
                </div>
                <div class="col-7">
                  <label for="Gun" class="font-bold block mb-2">Detaylar</label>
                  <Editor v-model="Aciklama" style="height:20vh; width:100%" />
                </div>
              </div>
            </Panel>
          </div>

          <div class="col-12">
            <IslemYapiliyor v-if="IslemYapiliyor" />
          </div>
          <div class="col-12 flex justify-content-end flex-wrap">
            <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small" severity="success"
              @click="this.handleClick()" autofocus :disabled="IslemYapiliyor" v-if="!IslemYapiliyor" />
          </div>
        </div>

      </template>
    </Card>

    <Dialog v-model:visible="DiyetElemanModal" header="Yemek Ekle" :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
      :style="{ width: '25vw' }" modal>

      <div class="formgrid grid ">
        <div class="field col md:col-12">
          <label for="OgunAd" class=" block">Öğün</label>
          <Select id="Grup" v-model="pOgun" :options="OgunListesi" optionLabel="Ad" optionValue="Ogun_rowid"
            placeholder="Seçiniz..." checkmark filter :highlightOnSelect="true" :invalid="this.Valid.pOgun"
            class="text-base text-color w-full" />
        </div>
        <div class="field col md:col-12">
          <label for="TarifAd" class=" block">TarifAd</label>
          <Select id="Grup2" v-model="pTarif" :options="TarifListesi" optionLabel="TarifAd" optionValue="Tarif_rowid"
            placeholder="Seçiniz..." checkmark filter :highlightOnSelect="true" :invalid="this.Valid.pTarif"
            class="text-base text-color w-full" @change="TarifChange" />
        </div>
        <div class="field col md:col-12">
          <InputNumber v-model="Miktar" showButtons buttonLayout="horizontal" :step="1" :min="0" :max="9999" fluid
            class="text-base text-color w-full" :suffix="BirimAd">
            <template #incrementbuttonicon>
              <span class="pi pi-plus" />
            </template>
            <template #decrementbuttonicon>
              <span class="pi pi-minus" />
            </template>
          </InputNumber>
        </div>
      </div>
      <Divider />
      <div class="flex justify-content-end flex-wrap">
        <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small" severity="success"
          @click="this.modalhandleClick()" autofocus />
        <Button class="m-1" label="Kapat" icon="pi pi-times" iconPos="right" size="small" severity="danger"
          @click="this._DiyetModal()" />
      </div>
    </Dialog>

  </div>
</template>

<script>
import GlobalServis from "../../../../../services/GlobalServis";
import BasicDataTable_RowGroup from "../../DataTable/BasicDataTable_RowGroup.vue";

export default {
  data() {
    return {
      DataTable_render: true,
      DiyetElemanModal: false,
      columns: [
        { field: "OgunAd", header: "Ögün Adı" },
        { field: "TarifAd", header: "Tarif Adı" },
      ],
      //---
      DiyetDetay: [],
      OgunListesi: [],
      TarifListesi: [],
      //---
      pTarif: 0,
      pOgun: 0,
      Miktar: 0,
      BirimAd: "",
      // Modal Validation Elements
      ModalValid: {
        pTarif: false,
        pOgun: false,
        Miktar: false,
      },

      //------------------
      IslemYapiliyor: false,
      DiyetTanim_rowid: 0,
      DiyetAd: "",
      Gun: "",
      Aciklama: "",
      //--------------
      DiyetSablon_rowid: 0,
      //---------
      DiyetElemanModalDurum: null,
      // Validation Elements
      Valid: {
        DiyetAd: false,
        Gun: false,
        Aciklama: false,
      }
    };
  },
  methods: {
    handleClick() {
      if (this._FormCheck()) { return; }
      this.IslemYapiliyor = true;


      let data = {
        DiyetTanim_rowid: this.DiyetTanim_rowid,
        DiyetAd: this.DiyetAd,
        Gun: this.Gun,
        Aciklama: this.Aciklama,
      };
      GlobalServis.GlobalServis("POST", "UpdateDiyetTanim", data).then((res) => {
        if (res.status == 200) {
          this.$toast.add({
            severity: "success",
            summary: "Başarılı",
            detail: "Diyet oluşturulmuştur",
            life: 3000,
          });
          this._ResetForm();
          this._DiyetInfo();
        } else if (res.response.status === 999) {
          this.$toast.add({
            severity: "warn",
            summary: "Uyarı",
            detail: res.response.data,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Hata oldu",
            life: 3000,
          });
        }
      }).then(() => {
        this.IslemYapiliyor = false;
        this.$router.push({ path: "/Diyetisyen/DiyetTanimListesi" });
      });
    },
    _DiyetInfo() {
      this.DiyetTanim_rowid = this.$route.query.DiyetNo;
      let data = {
        DiyetTanim_rowid: this.$route.query.DiyetNo,
      };
      GlobalServis.GlobalServis("POST", "GetDiyetTanimInfo", data).then((res) => {
        if (res.status == 200) {

          this.DiyetAd = res.data[0].Ad;
          this.Gun = res.data[0].Gun;
          this.Aciklama = res.data[0].Aciklama;

          this.IsWait = true;

        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    _ResetForm() {
      this.DiyetAd = "";
      this.Gun = "";
      this.Aciklama = "";
    },
    _FormCheck() {
      let Check = false;
      if (this.DiyetAd === "") {
        this.Valid.DiyetAd = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Diyet adı girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.DiyetAd = false; Check = false; }

      if (this.Gun === "") {
        this.Valid.Gun = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Gun girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.Gun = false; Check = false; }


      if (this.Aciklama === "") {
        this.Valid.Aciklama = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Diyet girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.Aciklama = false; Check = false; }

      return Check;
    },

    //-----------------+
    modalhandleClick() {
      if (this._ModalFormCheck()) { return; }
      this.IslemYapiliyor = true;


      if (this.DiyetElemanModalDurum) {
        // Yeni Kayıt
        let data = {
          pDiyetTanim: this.DiyetTanim_rowid,
          pTarif: this.pTarif,
          pOgun: this.pOgun,
          Miktar: this.Miktar,
        };
        GlobalServis.GlobalServis("POST", "SetDiyetSablon", data).then((res) => {
          if (res.status == 200) {
            this.$toast.add({
              severity: "success",
              summary: "Başarılı",
              detail: "Diyet oluşturulmuştur",
              life: 3000,
            });
            this.Refresh();
            // this._ResetForm();
            this._DiyetElemanModal();
            this._DiyetInfo();
          } else if (res.response.status === 999) {
            this.$toast.add({
              severity: "warn",
              summary: "Uyarı",
              detail: res.response.data,
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Hata oldu",
              life: 3000,
            });
          }
        }).then(() => {
          this.IslemYapiliyor = false;
        });


      }
      else {
        let data = {
          DiyetSablon_rowid: this.DiyetSablon_rowid,
          pTarif: this.pTarif,
          pOgun: this.pOgun,
          Miktar: this.Miktar,
        };

        GlobalServis.GlobalServis("POST", "UpdateDiyetSablon", data).then((res) => {
          if (res.status == 200) {
            this.$toast.add({
              severity: "success",
              summary: "Başarılı",
              detail: "AltKategori düzenlemiştir",
              life: 3000,
            });
            this.Refresh();
            this._DiyetElemanModal();
            this._DiyetInfo();
          } else if (res.response.status === 999) {
            this.$toast.add({
              severity: "warn",
              summary: "Uyarı",
              detail: res.response.data,
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Hata oldu",
              life: 3000,
            });
          }
        }).then(() => {
          this.IslemYapiliyor = false;
        });

      }
    },
    getDataChild(getdata_child) {
      this.ResetForm();

      this.DiyetElemanModal = !this.DiyetElemanModal;
      this.DiyetElemanModalDurum = false;
      this.DiyetSablon_rowid = getdata_child.data.DiyetSablon_rowid;

      let data = {
        DiyetSablon_rowid: getdata_child.data.DiyetSablon_rowid,
        pDiyetTanim: this.DiyetTanim_rowid,
        pTarif: getdata_child.data.Tarif_rowid,
        pOgun: getdata_child.data.Ogun_rowid,
      };

      GlobalServis.GlobalServis("POST", "GetDiyetSablonInfo", data).then((res) => {
        if (res.status == 200) {
          this.pTarif = res.data[0].pTarif;
          this.pOgun = res.data[0].pOgun;
          this.Miktar = res.data[0].Miktar;
          this.BirimAd = res.data[0].BirimAd;


        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });

    },
    _DiyetElemanModal() {
      this.ResetForm();
      this.DiyetElemanModal = !this.DiyetElemanModal;
      this.DiyetElemanModalDurum = true;
    },
    _OgunListesi() {
      GlobalServis.GlobalServis("GET", "GetOgunTablosu", "").then((res) => {
        if (res.status == 200) {
          this.OgunListesi = res.data;
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    _TarifListesi() {
      GlobalServis.GlobalServis("GET", "GetTarifTablosu", "").then((res) => {
        if (res.status == 200) {
          this.TarifListesi = res.data;
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    TarifChange(e) {
      this.BirimAd = " " + this.TarifListesi.find(tarif => tarif.Tarif_rowid === e.value).BirimAd;
    },
    _DiyetSablonTablosu() {
      let data = {
        DiyetTanim_rowid: this.DiyetTanim_rowid
      };
      GlobalServis.GlobalServis("POST", "GetDiyetSablonTablosu", data).then((res) => {
        if (res.status == 200) {
          // this.DiyetDetay = res.data;
          this.DiyetDetay = res.data.slice().sort((a, b) => a.Ogun_rowid - b.Ogun_rowid);

        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    _ModalFormCheck() {
      let Check = false;
      if (this.pTarif === 0) {
        this.ModalValid.pTarif = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Tarif girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.ModalValid.pTarif = false; Check = false; }

      if (this.pOgun === 0) {
        this.ModalValid.pOgun = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Öğün girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.ModalValid.pOgun = false; Check = false; }


      if (this.Miktar === 0) {
        this.ModalValid.Miktar = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Miktar girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.ModalValid.Miktar = false; Check = false; }

      return Check;
    },
    ResetForm() {
      this.pTarif = 0;
      this.pOgun = 0;
      this.Miktar = 0;
      this.BirimAd = "";
    },
    Refresh() {
      this.DataTable_render = false;
      this.$nextTick(() => {
        this._DiyetSablonTablosu();
        this.DataTable_render = true;
      });
    },
  },
  mounted() {
    this._DiyetInfo();

    this._TarifListesi();
    this._OgunListesi();
    this._DiyetSablonTablosu();
  },
  components: {
    BasicDataTable_RowGroup
  },
};
</script>